module.exports = __webpack_public_path__ + "Fram414-49532d67.webp";